import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row modal-option-modify" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_5 = { class: "p-5 h-100 overflow-y-scroll text-start pb-4" }
const _hoisted_6 = { class: "form-floating mb-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-floating mb-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "d-flex w-100 gap-2" }
const _hoisted_11 = { class: "flex-fill" }
const _hoisted_12 = { class: "form-check form-switch" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = { class: "form-floating flex-fill" }
const _hoisted_15 = { class: "flex-fill" }
const _hoisted_16 = { class: "form-check form-switch" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { class: "form-floating flex-fill" }
const _hoisted_19 = { class: "bg-light p-5 pt-0" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "d-flex w-100 align-items-stretch" }
const _hoisted_24 = { class: "m-0 pe-3 me-3 border-end align-items-center d-flex text-primary" }
const _hoisted_25 = { class: "d-flex flex-column w-100" }
const _hoisted_26 = { class: "d-flex mb-3" }
const _hoisted_27 = ["name", "value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "form-floating flex-fill"
}
const _hoisted_30 = ["value", "name"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 1,
  class: "form-floating flex-fill"
}
const _hoisted_34 = { class: "form-floating flex-fill" }
const _hoisted_35 = ["value", "name"]
const _hoisted_36 = { class: "d-flex align-items-center justify-content-center ms-3 flex-column" }
const _hoisted_37 = ["name"]
const _hoisted_38 = { class: "d-flex w-100 gap-2 mt-3" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "button-style": "primary",
    "button-class": _ctx.buttonClass,
    "modal-size": "modal-lg",
    ref: "modal"
  }, _createSlots({
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex border-bottom align-items-center px-4", 'bg-secondary text-white'])
        }, [
          (_ctx.option)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: _normalizeClass(["border-0", 'text-start'])
              }, [
                _cache[19] || (_cache[19] = _createTextVNode(" Modificando: ", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.currentData.name ?? _ctx.optionData.name), 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", {
                key: 1,
                class: _normalizeClass(["border-0", 'text-start'])
              }, " Nuevo elemento ")),
          _createElementVNode("button", {
            class: "btn btn-outline-light ms-auto",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args))),
            disabled: !_ctx.editing
          }, " Reestablecer ", 8, _hoisted_2),
          _createElementVNode("button", {
            class: "btn btn-primary ms-2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args))),
            disabled: !_ctx.editing
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Guardar cambios")
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: _ctx.currentData.name ?? _ctx.optionData.name,
              name: "name",
              autocomplete: "false"
            }, null, 40, _hoisted_7),
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "Nombre", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("textarea", {
              type: "text",
              class: "form-control",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: _ctx.currentData.description ?? _ctx.optionData.description ?? ' ',
              name: "description",
              autocomplete: "false",
              style: {"height":"150px"}
            }, null, 40, _hoisted_9),
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Descripción", -1))
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("h5", null, "Fecha y hora", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckDefault",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enable_start) = $event)),
                  checked: _ctx.currentData.start || _ctx.optionData.start
                }, null, 8, _hoisted_13), [
                  [_vModelCheckbox, _ctx.enable_start]
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexSwitchCheckDefault"
                }, " Activar hora de inicio ", -1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_VueDatePicker, {
                  disabled: !_ctx.enable_start,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = 
                    (value) => _ctx.modifyValue({ target: { name: 'start', value } })
                  ),
                  "model-value": _ctx.currentData.start || _ctx.optionData.start,
                  name: "start",
                  vertical: "",
                  "enable-time-picker": true,
                  "is-24": false,
                  "time-picker-inline": "",
                  class: "form-control p-0",
                  "min-date": new Date(),
                  format: _ctx.formatDate
                }, null, 8, ["disabled", "model-value", "min-date", "format"]),
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "Fecha y hora de inicio", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckDefault",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.enable_end) = $event)),
                  checked: _ctx.currentData.end || _ctx.optionData.end
                }, null, 8, _hoisted_17), [
                  [_vModelCheckbox, _ctx.enable_end]
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexSwitchCheckDefault"
                }, " Activar hora de finalización ", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_VueDatePicker, {
                  disabled: !_ctx.enable_end,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = 
                    (value) => _ctx.modifyValue({ target: { name: 'end', value } })
                  ),
                  "model-value": _ctx.currentData.end || _ctx.optionData.end,
                  name: "end",
                  vertical: "",
                  "enable-time-picker": true,
                  "is-24": false,
                  "time-picker-inline": "",
                  class: "form-control p-0",
                  "min-date": new Date(),
                  format: _ctx.formatDate
                }, null, 8, ["disabled", "model-value", "min-date", "format"]),
                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Fecha y hora de finalización", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h5", _hoisted_20, [
            _cache[29] || (_cache[29] = _createTextVNode(" Configuración de cargo ", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary ms-auto",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addDiscount && _ctx.addDiscount(...args)))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
            ]))])
          ]),
          (
              (_ctx.currentData?.options ?? _ctx.optionData?.options) &&
              (_ctx.currentData?.options ?? _ctx.optionData?.options).length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentData?.options ??
              _ctx.optionData?.options, (discount, ind) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card mb-3 payment-option-item",
                    key: ind
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h2", _hoisted_24, _toDisplayString(ind + 1), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["form-floating flex-fill", `${
                          _ctx.getOptions(ind)?.type != 'specific_date'
                            ? 'w-75'
                            : 'w-25'
                        } ${
                          _ctx.getOptions(ind)?.type == 'immediately'
                            ? 'me-0'
                            : 'me-2'
                        }`])
                            }, [
                              _createElementVNode("select", {
                                class: "form-control",
                                name: `options-${ind}-type`,
                                value: _ctx.getOptions(ind)?.type,
                                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.option_types), ([key, value]) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: key,
                                    value: key
                                  }, _toDisplayString(value), 9, _hoisted_28))
                                }), 128))
                              ], 40, _hoisted_27),
                              _cache[30] || (_cache[30] = _createElementVNode("label", null, "Tipo de cobro", -1))
                            ], 2),
                            (
                          !['immediately', 'specific_date'].includes(
                            _ctx.getOptions(ind)?.type ?? ''
                          )
                        )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                                    value: _ctx.getOptions(ind)?.value,
                                    name: `options-${ind}-value`,
                                    autocomplete: "false"
                                  }, null, 40, _hoisted_30),
                                  (_ctx.getOptions(ind)?.type == 'day_next_month')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_31, "Día"))
                                    : (_openBlock(), _createElementBlock("label", _hoisted_32, "Días"))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.getOptions(ind)?.type == 'specific_date')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createVNode(_component_VueDatePicker, {
                                    "onUpdate:modelValue": 
                            (value) =>
                              _ctx.modifyValue({
                                target: { name: `options-${ind}-value`, value },
                              })
                          ,
                                    "model-value": _ctx.getOptionDate(_ctx.getOptions(ind)?.value),
                                    name: "start",
                                    vertical: "",
                                    "enable-time-picker": false,
                                    "is-24": false,
                                    "time-picker-inline": "",
                                    class: "form-control p-0",
                                    "min-date": new Date(),
                                    format: _ctx.formatDate
                                  }, null, 8, ["onUpdate:modelValue", "model-value", "min-date", "format"]),
                                  _cache[31] || (_cache[31] = _createElementVNode("label", null, "Fecha", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                              value: _ctx.getOptions(ind)?.percentage,
                              name: `options-${ind}-percentage`,
                              autocomplete: "false"
                            }, null, 40, _hoisted_35),
                            _cache[32] || (_cache[32] = _createElementVNode("label", null, "Porcentaje (%)", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            class: "btn btn-danger",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.removeDiscount && _ctx.removeDiscount(...args))),
                            name: `${ind}`
                          }, [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                          ]))], 8, _hoisted_37)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-secondary ms-auto",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args))),
              disabled: !_ctx.editing
            }, " Reestablecer ", 8, _hoisted_39),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args))),
              disabled: !_ctx.editing
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Guardar cambios")
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                : _createCommentVNode("", true)
            ], 8, _hoisted_40)
          ])
        ])
      ])
    ]),
    _: 2
  }, [
    (_ctx.option)
      ? {
          name: "button",
          fn: _withCtx(() => [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-pencil-alt me-2" }, null, -1)),
            _cache[16] || (_cache[16] = _createTextVNode("Modificar ", -1))
          ]),
          key: "0"
        }
      : {
          name: "button",
          fn: _withCtx(() => [
            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1)),
            _cache[18] || (_cache[18] = _createTextVNode("Agregar ", -1))
          ]),
          key: "1"
        }
  ]), 1032, ["button-class"]))
}